export default "__VITE_ASSET__ggmcXXEy__"